import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const InfoIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon data-testid="info-icon" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM9 5.68V4H7V5.68H9ZM9 12.758V6.758H7V12.758H9Z"
      fill="currentColor"
    />
  </Icon>
);
